import apiClient from "../../../network/apiClient";

export const login = (body) => apiClient.post("/auth/login", body)
export const updatePasswordAPI = (body) => apiClient.patch("/auth/changePassword", body)